import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Col, Row, MultiSelection } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { FaBook } from 'react-icons/fa';
import SettingsCardWrapper from './SettingsCardWrapper';
import { modeFormatter } from '../shared/formatters';
import css from '../../styles.css';

function VolumeManagementCard({ modeOfIssuanceOptions, pending }) {
  const { formatMessage } = useIntl();

  return (
    <SettingsCardWrapper
      titleId="ui-plugin-inventory-templates.templatesOtherSettings.sections.volumeManagement"
      defaultTitle="Volume Management Settings"
      icon={FaBook}
    >
      <Row>
        <Col xs={12}>
          <Field
            id="enableVolumeManagement"
            name="volumeManagement.enableVolumeManagement"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.enableVolumeManagement"
                defaultMessage="Enable automatic volume management"
              />
            }
            type="checkbox"
            onMouseDown={(e) => e.preventDefault()}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            id="volumeManagementModeOfIssuance"
            name="volumeManagement.volumeManagementModeOfIssuance"
            component={MultiSelection}
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.volumeManagementModeOfIssuance"
                defaultMessage="Modes of issuance for volume management"
              />
            }
            placeholder={formatMessage({
              id: 'ui-plugin-inventory-templates.templatesOtherSettings.fields.volumeManagementModeOfIssuance.placeholder',
              defaultMessage: 'Select modes of issuance',
            })}
            dataOptions={modeOfIssuanceOptions}
            formatter={modeFormatter(formatMessage)}
            loading={pending}
            disabled={pending}
            fullWidth
          />
        </Col>
        <Col className={css.infoMsg} style={{ fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.sections.volumeManagement.info"
            defaultMessage="When enabled, the volume management system will be automatically activated in the items creation step based on the selected modes of issuance. If any of the selected modes is chosen in the bibliographic data step, volume management features will be available."
          />
        </Col>
      </Row>
    </SettingsCardWrapper>
  );
}

VolumeManagementCard.propTypes = {
  modeOfIssuanceOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  pending: PropTypes.bool.isRequired,
};

export default VolumeManagementCard;
